import { render, staticRenderFns } from "./ProductComplexitySection.vue?vue&type=template&id=b9b2287c&"
import script from "./ProductComplexitySection.vue?vue&type=script&lang=js&"
export * from "./ProductComplexitySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports